import styled from 'styled-components'
import { Colors } from 'config'

export const App = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    /* background-color: ${Colors.BLACK} */
`
